const store = new Map()

function has(key) {
  return store.has(key)
}

function get(key) {
  return store.get(key)
}

function set(key, value) {
  store.set(key, value)
}

function remove(key) {
  store.delete(key)
}

function clear() {
  store.clear()
}

function removeByPrefix(prefix) {
  for (const key of store.keys()) {
    if (key.startsWith(prefix)) {
      store.delete(key)
    }
  }
}

export function cachedRequest(key, request) {
  if (!has(key)) {
    const promise = request().catch(error => {
      if (get(key) === promise) remove(key)
      throw error
    })

    set(key, promise)
  }

  return get(key)
}

export function invalidateRequest(key) {
  remove(key)
}

export function invalidateRequestsByPrefix(prefix) {
  removeByPrefix(prefix)
}

export function clearRequestCache() {
  clear()
}
